var Component = require("!../../_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./slide.vue"),
  /* template */
  require("!!../../_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-cd87ad68\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./slide.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-awesome-swiper@2.6.7@vue-awesome-swiper/src/slide.vue
// module id = 590
// module chunks = 64